// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import {createRoot} from 'react-dom/client';

import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';
import AuthGate from './auth-gate.jsx';

import styles from './index.css';

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

if (supportedBrowser()) {
    // Show auth gate first; on success unmount it and render the editor.
    // require() is deferred here to avoid importing VM code in unsupported browsers.
    const root = createRoot(appTarget);
    const handleAuthorized = () => {
        root.unmount();
        require('./render-gui.jsx').default(appTarget);
    };
    // eslint-disable-next-line react/jsx-no-bind
    root.render(<AuthGate onAuthorized={handleAuthorized} />);

} else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    const handleBack = () => {};
    const root = createRoot(appTarget);
    // eslint-disable-next-line react/jsx-no-bind
    root.render(<WrappedBrowserModalComponent onBack={handleBack} />);
}
